var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcToleranceClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C6.21023 22.5 1.5 17.7898 1.5 12C1.5 6.21023 6.21023 1.5 12 1.5C17.7898 1.5 22.5 6.21023 22.5 12C22.5 17.7898 17.7898 22.5 12 22.5ZM12 3C7.03747 3 3 7.03747 3 12C3 16.9625 7.03747 21 12 21C16.9625 21 21 16.9629 21 12C21 7.0371 16.9629 3 12 3ZM15.2197 16.2803L11.25 12.3105V5.25H12.75V11.6894L16.2803 15.2197L15.2197 16.2803ZM9.75 12.75H8.25V11.25H9.75V12.75ZM6.75 12.75H5.25V11.25H6.75V12.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToleranceClock);
export default __webpack_public_path__ + "static/media/ic-tolerance-clock.b3176c0cbf9b409fd3f6285039cdbaff.svg";
export { ForwardRef as ReactComponent };